'use strict';

class deletableInvoiceService {
  constructor($http) {
    this.$http = $http;
  }

  list() {
    return this.$http.get(`/invoices/deletable`);
  }

  delete(invoiceNumber) {
    return this.$http.delete(`/invoices/${invoiceNumber}`);
  }

  deleteDeletableInvoices() {
    return this.$http.delete(`/invoices/deletable`);
  }
}

deletableInvoiceService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('deletableInvoiceService', deletableInvoiceService);
